/**
 * 통합검색이 세션에 담는 값의 열쇠.
 *
 * 주소에 싣지 않는 화면 상태(검색어·필터·AI chat)가 여기 들어간다 — 링크에 검색어가 남지 않게 하려는 것이다.
 * ⚠️ 탭을 닫으면 사라진다(`sessionStorage`). 여러 파일이 같은 열쇠를 봐야 해서 이름은 여기 한 곳에만 둔다.
 */

/** 소재 찾기 화면의 값 한 벌(JSON) */
export const SEARCH_ALL_MEDIA_STATE_KEY = 'search-all:media';

/** AI chat 에 담은 소재(JSON) — 카드 스냅샷까지 담아 새로고침 없이 되살린다 */
export const SEARCH_ALL_AI_CART_KEY = 'search-all:ai-cart';

/** AI chat 대화(JSON) — 탭을 닫으면 사라진다. 보관본은 워크스페이스에 따로 남는다 */
export const SEARCH_ALL_AI_CHAT_KEY = 'search-all:ai-chat';

/** 보관된 대화 id — 두 번째 물음부터 같은 대화를 덮어쓰려고 쥔다 */
export const SEARCH_ALL_AI_CHAT_ID_KEY = 'search-all:ai-chat-id';
